<template>
  <transition name="fade" mode="out-in">

    <div class="animated fadeIn form-mimoto">

    <CRow class="mb-4">
      <CCol md="12">
        <h2> <strong> {{elemento}}</strong> </h2>
        <p class="mb-0" v-if="parking"> Selecciona la fecha de inicio del plan  <strong>{{ parkingPlan }}</strong>  en el parking
          <strong>{{ parking.name }}</strong> </p>
      </CCol>
    </CRow>


    <CCard>
      <CCardBody borderColor="primary">
        <h5 class="subtitle mb-1">4. Fecha de inicio</h5>
        <p class="mb-3 text-primary">Selecciona una fecha de inicio para tu plan prepago</p>

        <CForm @submit.prevent data-vv-scope="new-delivery">

          <CRow>
            <CCol sm="12">

              <div role="group" class="form-group">
                <label class="required" for="name">Rango de fechas</label>
                  <date-picker
                  v-model="product.dates"
                  id="plan_dates" name="plan_dates"
                  type="date"
                  value-type="YYYY-MM-DD"
                  format="DD/MM/YYYY"
                  :lang="lang"
                  :range="true"
                  placeholder="Selecciona una fecha"
                  :class="{ 'is-invalid': errors.first('new-delivery.plan_dates') }"
                  v-validate="'required'" data-vv-validate-on="change"
                  v-bind:invalid-feedback="errors.first('new-delivery.plan_dates')"
                  required
                  >
                  <template slot="icon-calendar"> <CIcon name="cil-calendar"/></template>
                  </date-picker>

                  <p class="error-field mt-2" v-if="errors.first('new-delivery.plan_dates') || errorDates">
                    <span>El rango de fechas es obligatorio</span></p>
                </div>

            </CCol>

          </CRow>


        </CForm>

        <p class="invalid-feedback d-block mt-4 mb-3">
          {{ message }}
        </p>

       <toast ref="toast"></toast>

      </CCardBody>
    </CCard>

    <div class="title-container mb-3 btn-new-delivery">
      <button @click.prevent="saveDelivery"
      class="btn-login-custom btn" >
        Siguiente
        <!-- Proceder al pago -->
      </button>
    </div>

    <spinner-ttt :show="loading"></spinner-ttt>


    </div>
  </transition>
</template>

<script>
import validator from "@/validator";
// import apiTools from "@/app/shared/utils/apiTools"
import { CALENDAR_LANG } from "@/config";

import { createDelivery, getProductStore, setProductStore } from "@/app/shared/global/services/product-service";

import { fetchOneParking } from "@/app/shared/global/services/parking-service";
// detalle del plan seleccionado

import { fetchOnePlan }  from "@/app/shared/global/services/plan-service";

export default {
  name: "ContractPlan",
  components: {

  },
  data() {
    return {
      step: 4,
      elemento: "Inicio del Plan",
      loading: true,
      message: null,

      product: {
        clients_id: localStorage.getItem('user_id'),
        towns_id: null, // solo para ir hacia a trás
        parkings_id: null,
        plans_id: null, // plans
        start_datetime: null,
        end_datetime: null,
        dates: [],
        hours:[],
      },

      errorDates: false,
      lang: CALENDAR_LANG,

      contractPlanApi: null,

      errorPlan: false,

      parkings: [],
      planes: [],
      parking: null,

    };
  },
  created() {
    // this.getParking();
  },
  async mounted(){

    this.$emit("updateStep", this);
    this.$emit("showButtons", false);

    if (getProductStore()){
      await this.setDataLocalStorage();
    }

    this.getParking();

  },
  computed: {

    parkingPlan() {

      if (this.parking.plans) {

        let plan = this.parking.plans.find(item => {
          if ( item.plan.id == this.product.plans_id) {
            return item.plan
          }
        });

        return plan.plan.name
      }

    }

  },

  methods: {

    async getPlan() {

      try {

        const resp = await fetchOnePlan(this.product.plans_id);

        if (resp.status !== 'success') {
          this.$refs.toast.showToast(`Error al obtener el plan seleccionado`, null, 'error', '2000');
          return;
        }

        this.parking = resp.data;

      } catch (err) {
        console.log(err);
        this.$refs.toast.showToast(`Error al obtener el plan seleccionado`, null, 'error', '2000');

      } finally {
        this.loading = false;
      }


    },

    async getParking() {

      try {

        const resp = await fetchOneParking(this.product.parkings_id);

        if (resp.status !== 'success') {
          this.$refs.toast.showToast(`Error al obtener el parkings`, null, 'error', '2000');
          return;
        }

        this.parking = resp.data;

      } catch (err) {
        console.log(err);
        this.$refs.toast.showToast(`Error al obtener el parking`, null, 'error', '2000');

      } finally {
        this.loading = false;
      }
    },

    saveDelivery() {

      this.$validator.validateAll('new-delivery').then( async (valid) => {

        if (this.product.dates.length <= 0 || this.product.dates.some(date => date === null)) {
          this.message = `Debes indicar el rango de fechas que aplicará el ${this.element}`;
          this.errorDates = true;
        }

        if (valid ) {

          this.loading = true;
          const errorMessage = `Se ha producido un error seleccionar la fecha`;

          try {

            const start_datetime = this.product.dates[0];
            const end_datetime = this.product.dates[1];

            const contractToSave = {
              ...this.product,
              parkings_id: this.product.parkings_id.value,
              start_datetime,
              end_datetime
            }


            this.contractPlanApi = {...contractToSave};

            this.nextStep();

          } catch (e) {
            console.log(e);
            this.$refs.toast.showToast(`${errorMessage}`, null, 'error', '2000');

          } finally {
            this.loading = false;
          }

        } else {
          this.$refs.toast.showToast("Todos los campos son requeridos",null,"error","5000");
        }
      })
    },

    setDataLocalStorage() {

      const errorMessage = `Se ha producido un error al obtener los datos en curso`;
      this.loading = true;

      try {
        let storedData = getProductStore();

        if (storedData) {

          this.product = { ...storedData };
        }

      } catch (e) {
        console.log(e);
        // this.$refs.toast.showToast(`${errorMessage}`,null,"warn","5000");
      } finally {
        this.loading = false;
      }

    },

    saveDataLocalStorage() {
      setProductStore(this.contractPlanApi);
    },


    nextStep() {

      this.loading = true;
      this.saveDataLocalStorage();

      // const data = { valid: true, parkingId: this.contractPlanApi.parkings_id }

      this.$emit("validForm", { valid: true, parkingId: this.contractPlanApi.parkings_id } );
      this.loading = false;



    },



    formatDataSelect(ad) {

      if (ad) {
        const label = ad.store ? `${ad.alias} - ${ad.address}` : ad.address

        return {
          label: label, //`${ad.alias} - ${ad.address}`,
          value: ad.id
        }
      }
    },






  }
};
</script>

<style lang="scss" scoped>


.input-group-append {
  .input-group-text {
    color: #1c1f22; //#5c6873;
    background-color: var(--theme-color-primary)!important;// #f0f3f5; //
    border-color: var(--theme-color-primary); //#e4e7ea;
  }
}


</style>
